import isEmpty from 'lodash.isempty'

type OptimisticResponseVariables<T> = T | {}

export const hasOptimisticResponseVariables = <T>(
  value: OptimisticResponseVariables<T>
): value is T => !isEmpty(value)
